var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2494 14.4977C11.6638 14.4977 11.9997 14.8335 11.9997 15.2477C11.9997 15.6274 11.7174 15.9412 11.3512 15.9909L11.2494 15.9977H0.750029C0.335631 15.9977 -0.000305176 15.6619 -0.000305176 15.2477C-0.000305176 14.868 0.281975 14.5542 0.648214 14.5046L0.750029 14.4977H11.2494ZM6.006 -0.000488281C6.38586 -0.000488281 6.6998 0.281666 6.74948 0.647741L6.75633 0.749512L6.75571 10.9425L9.72325 7.97193C9.98939 7.70542 10.4062 7.68083 10.7002 7.89841L10.7844 7.97095C11.051 8.23697 11.0756 8.65362 10.8579 8.94743L10.7854 9.03161L6.54064 13.2823L6.46995 13.3448L6.37894 13.4034L6.3425 13.4245L6.25128 13.4625L6.13075 13.4926L6.06146 13.5005L6.00137 13.5024C5.95123 13.5024 5.90033 13.4969 5.85058 13.4863L5.76968 13.4632C5.67362 13.4322 5.58647 13.382 5.51229 13.3172L1.2208 9.03248C0.927567 8.73979 0.927229 8.26492 1.22004 7.97182C1.48624 7.70536 1.90307 7.68086 2.19697 7.89851L2.28118 7.97106L5.25504 10.9385L5.25566 0.749512C5.25566 0.335298 5.5916 -0.000488281 6.006 -0.000488281Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.31acdcde574a69a20810e3164c6f1a32.svg";
export { ForwardRef as ReactComponent };